module.exports = __webpack_public_path__ + "img/quato4.38122424.png";